export const InvoiceApprovalAction = {
    AddInvoiceForApproval: "ADDINVOICEFORAPPROVAL",
    RemoveInvoiceForApproval:"REMOVEINVOICEFORAPPROVAL"
}

const initInvoiceApproval = [];

const InvoiceApprovalReducer = (invApproval = initInvoiceApproval, actions) => {

    switch (actions.type) {
        case InvoiceApprovalAction.AddInvoiceForApproval:
            //payUpdtData = [];
            invApproval.push(actions.payload);
            return invApproval;
        case InvoiceApprovalAction.RemoveInvoiceForApproval:
            var res = invApproval.filter((item) => item.Id !== actions.payload);
            invApproval = [];
            invApproval = res;
            return invApproval;
        default:
            return invApproval;
    }
}
export default InvoiceApprovalReducer;